<div class="gc-form-group">
    <label class="gc-form-group__label">{{ label }}</label>
    
    <div class="multiselect-combobox-input-container" outsideClick (outsideClick)="onOutsideClick()">
        <div class="multiselect-combobox-input" [ngClass]="{'opened': isOpened}" (click)="processOpen()">
            <input class="multiselect-combobox-input-search" id="{{name}}search" [(ngModel)]="filterText"/>
            <div class="multiselect-combobox-input-summary">
                <div *ngIf="this.selectedItems && this.selectedItems.length > 0">
                    <span class="selected-multiselect-combobox">{{this.selectedItems[0].label}}</span>
                    <span class="extra-count-tag" *ngIf="this.selectedItems.length > 1">+{{this.selectedItems.length - 1}}</span>
                </div>

                <div *ngIf="!this.selectedItems || this.selectedItems.length == 0">
                    {{ unselectedOptionLabel }}
                </div>
            </div>

            <span class="select-icon icon-Property-3cheveron-down" (click)="isOpened = !isOpened"></span>    
        </div>
        
        <div class="multiselect-combobox-popup">
            <div class="multiselect-combobox-list">
                <div *ngFor="let group of data">
                    <span class="multiselect-combobox-list-header" *ngIf="group.label && (group.items | filterCheckListItem:filterText).length > 0">{{ group.label }}</span>
                        <label class="form-check form-check-custom form-check-solid py-1" *ngFor="let item of group.items | filterCheckListItem:filterText">
                        <input
                            id="{{group.name}}_{{item.value}}"
                            type="checkbox"
                            name="{{group.name}}_{{item.value}}"
                            [(ngModel)]="item.checked"
                            class="form-check-input"
                            (ngModelChange)="onChange()"
                        />
                        <span class="form-check-label">
                            {{ item.label }}
                        </span>
                    </label>
                </div>
            </div>

            <a herf="javascript:void(0)" class="multiselect-combobox-clear-all" (click)="clear()">Clear All</a>
        </div>
    </div>
    
</div>
